module.exports = __webpack_public_path__ + "static/img/500.c985cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/500.png
// module id = JE9E
// module chunks = 1